export default __webpack_public_path__ + "static/media/sweat.848185cd.png";